/**
 * Shared CSV export utilities used by every *Table export function.
 */

// Splits a Pods comma-separated field value into a trimmed, non-empty array.
export function splitValues( str ) {
	return str
		? str
				.split( ',' )
				.map( ( v ) => v.trim() )
				.filter( Boolean )
		: [];
}

function escapeCell( v ) {
	const s = String( v ?? '' );
	return s.includes( ',' ) || s.includes( '"' ) || s.includes( '\n' )
		? `"${ s.replace( /"/g, '""' ) }"`
		: s;
}

// Serialise headers + data rows to CSV and trigger a browser download.
// UTF-8 BOM is prepended for Excel compatibility.
export function downloadCsv( headers, dataRows, filename ) {
	const csv = [ headers, ...dataRows ]
		.map( ( row ) => row.map( escapeCell ).join( ',' ) )
		.join( '\r\n' );
	const blob = new Blob( [ '﻿' + csv ], { type: 'text/csv;charset=utf-8;' } );
	const url = URL.createObjectURL( blob );
	const a = document.createElement( 'a' );
	a.href = url;
	a.download = filename;
	a.click();
	URL.revokeObjectURL( url );
}
